// extracted by mini-css-extract-plugin
export default {"form_container":"Otp_form_container__FSMPc","left":"Otp_left__QXOSQ","right":"Otp_right__V1gJl"};